@let KEY_PREFIX = 'shop-settings.subscription.paymentMethod.changePayment-modal.';

<app-base-modal [title]="KEY_PREFIX + 'title' | translate">
  <p class="change-warning">
    {{ KEY_PREFIX + 'text' | translate }}
  </p>

  <app-modal-controls
    [primaryActionTextKey]="KEY_PREFIX + 'actions.change' | translate"
    [secondaryActionTextKey]="KEY_PREFIX + 'actions.cancel' | translate"
    (secondaryActionTriggered)="close()"
    (primaryActionTriggered)="proceed()"
  />
</app-base-modal>
